// extracted by mini-css-extract-plugin
export default {"root":"IconFilters_root__fEchx"};